module.exports = __webpack_public_path__ + "img/dead-tree-desert-05.89350192.png";